import { useState, useEffect } from "react";

// Hook
function useWindowSize() 
{
    //On détecte d’abord si on est côté client ou côté serveur
    const isClient = typeof window === "object";
    //Puis on définit la fonction getSize, qui retournera un objet contenant la hauteur et la largeur de la fenêtre :
    //si l’application est chargée dans le navigateur, les valeurs correspondront à la largeur et la hauteur de la fenêtre ; 
    //sinon, elles seront égales à undefined
    function getSize() 
        {
            return {
                width: isClient ? window.innerWidth : undefined,
                height: isClient ? window.innerHeight : undefined
                };
        }
    //Ensuite, on définit la variable d’état windowSize et la fonction pour la modifier setWindowSize, via un hook d’état
    const [windowSize, setWindowSize] = useState(getSize);
    //Le hook d’effet qui suit va d’abord s’assurer que nous sommes bien côté client, 
    //et va attacher un eventListener à la fenêtre qui va faire appel à la fonction handleResize à chaque changement de taille de la fenêtre
    useEffect(() => 
        {
            if (!isClient) 
                {
                    return false;
                }
            //Cette fonction quant à elle mettra à jour la largeur de l’écran en faisant appel à getSize()
            function handleResize() 
                {
                    setWindowSize(getSize());
                }

            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }, []); // Empty array ensures that effect is only run on mount and unmount

    return windowSize;
}

export default useWindowSize